import React from 'react';

export const EditBenefitGroup = () => {
  return <div> This is edit benefit group page placeholder</div>;
};
